import CardsActionTypes from './cards-types'

/***************  Get Card   ****************/
export const startGetCard = data => ({
    type: CardsActionTypes.START_GET_CARD,
    payload: data,
})
export const successGetCard = data => ({
    type: CardsActionTypes.SUCCESS_GET_CARD,
    payload: data,
})

/***************  Get Card programs  ****************/
export const getCardPrograms = data => ({
    type: CardsActionTypes.GET_CARD_PROGRAMS,
    payload: data,
})
export const successCardPrograms = data => ({
    type: CardsActionTypes.SUCCESS_CARD_PROGRAMS,
    payload: data,
})

/***************  Get Card shipping  ****************/
export const getCardShipping = data => ({
    type: CardsActionTypes.GET_CARD_SHIPPING,
    payload: data,
})
export const successCardShipping = data => ({
    type: CardsActionTypes.SUCCESS_CARD_SHIPPING,
    payload: data,
})

/***************  Card Order  ****************/

export const startCardOrder = data => ({
    type: CardsActionTypes.START_CARD_ORDER,
    payload: data,
})
export const successCardOrder = data => ({
    type: CardsActionTypes.SUCCESS_CARD_ORDER,
    payload: data,
})
export const finishCardOrder = data => ({
    type: CardsActionTypes.FINISH_CARD_ORDER,
    payload: data,
})
export const failureCardOrder = data => ({
    type: CardsActionTypes.FAILURE_CARD_ORDER,
    payload: data,
})

/************************ Card Top Up  ************************** */

export const startCardTopUp = data => ({
    type: CardsActionTypes.START_CARD_TOP_UP,
    payload: data,
})
export const successCardTopUp = data => ({
    type: CardsActionTypes.SUCCESS_CARD_TOP_UP,
    payload: data,
})
export const finishCardTopUp = data => ({
    type: CardsActionTypes.FINISH_CARD_TOP_UP,
    payload: data,
})
export const failureCardTopUp = data => ({
    type: CardsActionTypes.FAILURE_CARD_TOP_UP,
    payload: data,
})

/**************************** Card Withdraw  ********************* */

export const startCardWithdraw = data => ({
    type: CardsActionTypes.START_CARD_WITHDRAW,
    payload: data,
})
export const successCardWithdraw = data => ({
    type: CardsActionTypes.SUCCESS_CARD_WITHDRAW,
    payload: data,
})
export const finishCardWithdraw = data => ({
    type: CardsActionTypes.FINISH_CARD_WITHDRAW,
    payload: data,
})
export const failureCardWithraw = data => ({
    type: CardsActionTypes.FAILURE_CARD_WITHDRAW,
    payload: data,
})

/******************  Card Freeze   ********************* */

export const startCardFreeze = data => ({
    type: CardsActionTypes.START_CARD_FREEZE,
    payload: data,
})
export const successCardFreeze = data => ({
    type: CardsActionTypes.SUCCESS_CARD_FREEZE,
    payload: data,
})
export const finishCardFreeze = data => ({
    type: CardsActionTypes.FINISH_CARD_FREEZE,
    payload: data,
})
export const failureCardFreeze = data => ({
    type: CardsActionTypes.FAILURE_CARD_FREEZE,
    payload: data,
})

/******************  Card Unfreeze   ********************* */

export const startCardUnfreeze = data => ({
    type: CardsActionTypes.START_CARD_UNFREEZE,
    payload: data,
})
export const successCardUnfreeze = data => ({
    type: CardsActionTypes.SUCCESS_CARD_UNFREEZE,
    payload: data,
})
export const finishCardUnfreeze = data => ({
    type: CardsActionTypes.FINISH_CARD_UNFREEZE,
    payload: data,
})
export const failureCardUnfreeze = data => ({
    type: CardsActionTypes.FAILURE_CARD_UNFREEZE,
    payload: data,
})

/**************************** Card Activation  ********************* */

export const startCardActivation = data => ({
    type: CardsActionTypes.START_CARD_ACTIVATION,
    payload: data,
})
export const successCardActivation = data => ({
    type: CardsActionTypes.SUCCESS_CARD_ACTIVATION,
    payload: data,
})
export const finishCardActivation = data => ({
    type: CardsActionTypes.FINISH_CARD_ACTIVATION,
    payload: data,
})
export const failureCardActivation = data => ({
    type: CardsActionTypes.FAILURE_CARD_ACTIVATION,
    payload: data,
})

/******************  Card Deactivate   ********************* */

export const startCardDeactivate = data => ({
    type: CardsActionTypes.START_CARD_DEACTIVATE,
    payload: data,
})
export const successCardDeactivate = data => ({
    type: CardsActionTypes.SUCCESS_CARD_DEACTIVATE,
    payload: data,
})
export const finishCardDeactivate = data => ({
    type: CardsActionTypes.FINISH_CARD_DEACTIVATE,
    payload: data,
})
export const failureCardDeactivate = data => ({
    type: CardsActionTypes.FAILURE_CARD_DEACTIVATE,
    payload: data,
})

/******************  Card details   ********************* */

export const startCardDetails = data => ({
    type: CardsActionTypes.START_CARD_DETAILS,
    payload: data,
})
export const successCardDetails = data => ({
    type: CardsActionTypes.SUCCESS_CARD_DETAILS,
    payload: data,
})
export const finishCardDetails = data => ({
    type: CardsActionTypes.FINISH_CARD_DETAILS,
    payload: data,
})
export const failureCardDetails = data => ({
    type: CardsActionTypes.FAILURE_CARD_DETAILS,
    payload: data,
})

/************************ Start Receive Pin ***************************/

export const startReceivePin = data => ({
    type: CardsActionTypes.START_RECEIVE_PIN,
    payload: data,
})
export const successReceivePin = data => ({
    type: CardsActionTypes.SUCCESS_RECEIVE_PIN,
    payload: data,
})
export const finishReceivePin = data => ({
    type: CardsActionTypes.FINISH_RECEIVE_PIN,
    payload: data,
})
export const failureReceivePin = data => ({
    type: CardsActionTypes.FAILURE_RECEIVE_PIN,
    payload: data,
})
